import { Row, Col, Breadcrumb, BreadcrumbItem, Button } from 'reactstrap';
import { Link } from 'react-router-dom';

type FixedHeaderProps = {
  breadcrumbs: { label: string; path: string }[];
  title: string;
  subtitle?: string;
  onSave?: () => void;
  onDelete?: () => void;
  onBack?: () => void;
  isDeleting?: boolean;
  isUpdating?: boolean;
  isSaving?: boolean;
  canEdit?: boolean;
  canDelete?: boolean;
  canPerformAction?: boolean;
  canSubmit?: boolean;
  smallDescription?: string;
};

const FixedHeader = ({
  breadcrumbs,
  title,
  subtitle,
  onSave,
  onDelete,
  onBack,
  isDeleting = false,
  isSaving = false,
  canEdit = false,
  canDelete = false,
  canPerformAction = false,
  canSubmit = false,
  isUpdating = false,
  smallDescription
}: FixedHeaderProps) => {
  return (
    <div className="header-container fixed-header flex-fill">
      <Row className="d-flex align-items-center">
        <Col className="mb-3">
          <Breadcrumb className="mt-4">
            {breadcrumbs.map((item, index) => (
              <BreadcrumbItem
                key={index}
                active={index === breadcrumbs.length - 1}
              >
                {index === breadcrumbs.length - 1 ? (
                  <span className="text-gray-600 fw-medium">{item.label}</span>
                ) : (
                  <Link to={item.path} className="text-decoration-none">
                    {item.label}
                  </Link>
                )}
              </BreadcrumbItem>
            ))}
          </Breadcrumb>
          <h4 className="fw-bolder">{title}</h4>
          {subtitle && <h5 className="text-gray-600 mt-4">{subtitle}</h5>}
          <span className="small-typography text-gray-600">
            {smallDescription}
          </span>
        </Col>
        <Col className="d-flex align-items-center justify-content-end">
          <Button className="button-outline me-2" onClick={onBack}>
            Voltar
          </Button>
          {canDelete && (
            <Button
              type="button"
              loading={isDeleting}
              className="button-outline delete me-2"
              onClick={onDelete}
            >
              Excluir
            </Button>
          )}
          {(canEdit && (
            <Button
              type="submit"
              className="btn btn-primary text-white button-register"
              loading={isSaving || isUpdating}
              onClick={onSave}
              disabled={!canSubmit}
            >
              Salvar
            </Button>
          )) ||
            (canPerformAction && (
              <Button
                type="submit"
                className="btn btn-primary text-white button-register"
                loading={isSaving || isUpdating}
                onClick={onSave}
                disabled={!canSubmit}
              >
                Salvar
              </Button>
            ))}
        </Col>
      </Row>
    </div>
  );
};

export default FixedHeader;
